import { ref } from 'vue'
import {
  CreateMTagGroup,
  GetMTagGroups,
  FindMTagGroup,
  UpdateMTagGroup,
  DeleteMTagGroup,
} from '@/api/mTagGroup'
import { useShop } from '@/use/shop'
import { fetchAll } from '@/use/useFetchAll'

export const useTagGroup = () => {
  const { shopId } = useShop()
  const tagGroups = ref([])
  const loading = ref(false)

  /**
   * 取得所有群組（目前不分頁，一次載入）
   */
  const fetchTagGroups = async () => {
    if (loading.value) return
    loading.value = true
    const [list, err] = await fetchAll(GetMTagGroups, { shopId: shopId.value })
    loading.value = false
    if (err) {
      window.$message.error(err)
      return
    }
    tagGroups.value = list || []
  }

  /**
   * 建立群組
   * @param {string} name - 群組名稱
   * @returns {Promise<[Object|null, string|null]>}
   */
  const createGroup = async (name) => {
    return await CreateMTagGroup({ shopId: shopId.value, name })
  }

  /**
   * 查詢單筆群組（含完整 MTags）
   * @param {string} id - 群組 ID
   * @returns {Promise<[Object|null, string|null]>}
   */
  const findOneGroup = async (id) => {
    return await FindMTagGroup({ shopId: shopId.value, id })
  }

  /**
   * 更新群組（名稱 & 全量 mTags），更新成功後重新取得完整群組資料
   * @param {string} id - 群組 ID
   * @param {string} name - 群組名稱
   * @param {Array<{mTagId: string, order: number}>} mTags - 全量標籤（替換）
   * @returns {Promise<[Object|null, string|null]>} 返回更新後的完整群組
   */
  const updateGroup = async ({ id, name, mTags }) => {
    const [, err] = await UpdateMTagGroup({ shopId: shopId.value, id, name, mTags })
    if (err) return [null, err]
    return await FindMTagGroup({ shopId: shopId.value, id })
  }

  /**
   * 刪除群組
   * @param {string} id - 群組 ID
   * @returns {Promise<[Object|null, string|null]>}
   */
  const deleteGroup = async (id) => {
    return await DeleteMTagGroup({ shopId: shopId.value, id })
  }

  return {
    tagGroups,
    loading,
    fetchTagGroups,
    createGroup,
    findOneGroup,
    updateGroup,
    deleteGroup,
  }
}
